<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive
      :disabled="sas.demenagements.length === 0"
      code="demenagement_ouinon"
      :live="liveSasSociete(25934)"
      v-model="sasSociete.declarerDemenagementPharmacie"
    />
    <div v-show="conditionDemenagement">
      <data-iterator
        :list="getListDemenagements"
        add-new-text="Déménager une pharmacie"
        :live="{ endpoint: 'sas-demenagement', sasId: sas.id }"
        :icon="$getIcon('job')"
        :valids="valids"
        ref="dataIterator"
        hidePoints
        hideAddButton
        optional
      >
        <template v-slot:show-mode="{ item }">
          <OrganisationCardContent v-if="item.pharmacieDemenagee" :organisation="item.pharmacieDemenagee" />
          <CaseACocherLive
            :opqIf="conditionDemenagement"
            @eudo-updated="cocherDemenagee(item)"
            code="pharmacie_demenagee"
            v-model="item.jeSouhaiteDemenagerCettePharmacie"
            :live="liveSasDemenagement(26715, item)"
          />
        </template>
        <template v-slot:edit-mode="{ item }">
          <OrganisationCardContent v-if="item.pharmacieDemenagee" :organisation="item.pharmacieDemenagee" />
          <CatalogueLive
            :opqIf="item.jeSouhaiteDemenagerCettePharmacie"
            code="demenagement_type"
            v-model="item.typeDeDemenagement"
            :live="liveSasDemenagement(26703, item)"
            :filter="(fd) => fd.code === 'DEM' || fd.code === 'REL'"
            @eudo-updated="attachposteCanada(item)"
          />

          <DatePickerLive
            code="demenagement_date_debut"
            v-model="item.dateDemenagement"
            :live="liveSasDemenagement(26704, item)"
            :opqIf="item.jeSouhaiteDemenagerCettePharmacie"
          />
          <DatePickerLive
            code="demenagement_date_fin"
            v-model="item.dateRetourDeclaree"
            :live="liveSasDemenagement(26705, item)"
            :opqIf="estRelocalisation(item.typeDeDemenagement)"
          />
          <template v-if="item.jeSouhaiteDemenagerCettePharmacie && estRelocalisation(item.typeDeDemenagement)">
            <validate :that="item.dateRetourDeclaree > item.dateDemenagement" else="date_retour_doit_etre_superieure_date_demenagement" />
          </template>
          <TextFieldLive
            code="demenagement_adresse_ligne_1"
            v-model="item.adresseLigne1"
            :live="liveSasDemenagement(26706, item)"
            :ref="getId('adresse', item)"
            :id="getId('adresse-field', item)"
            :opqIf="item.jeSouhaiteDemenagerCettePharmacie"
          />
          <TextFieldLive
            code="demenagement_adresse_ligne_2"
            v-model="item.adresseLigne2"
            :live="liveSasDemenagement(26707, item)"
            :ref="getId('completementDAdresse', item)"
            :opqIf="item.jeSouhaiteDemenagerCettePharmacie"
          />
          <TextFieldLive
            code="demenagement_adresse_ville"
            v-model="item.ville"
            :live="liveSasDemenagement(26708, item)"
            :ref="getId('ville', item)"
            :opqIf="item.jeSouhaiteDemenagerCettePharmacie"
          />
          <TextFieldLive
            code="demenagement_adresse_codepostal"
            v-model="item.codePostal"
            :live="liveSasDemenagement(26709, item)"
            :ref="getId('codePostal', item)"
            :opqIf="item.jeSouhaiteDemenagerCettePharmacie"
          />
          <CatalogueLive
            code="demenagement_adresse_province"
            v-model="item.province"
            :live="liveSasDemenagement(26710, item)"
            :filter="(fd) => fd.code === 'QC'"
            :ref="getId('province', item)"
            :opqIf="item.jeSouhaiteDemenagerCettePharmacie"
          />
          <CatalogueLive
            code="demenagement_adresse_pays"
            v-model="item.pays"
            :live="liveSasDemenagement(26711, item)"
            :filter="(fd) => fd.code === 'CA'"
            :ref="getId('pays', item)"
            :opqIf="item.jeSouhaiteDemenagerCettePharmacie"
          />
          <TextFieldLive
            code="demenagement_telephone"
            v-model="item.telephone"
            :live="liveSasDemenagement(26712, item)"
            :opqIf="item.jeSouhaiteDemenagerCettePharmacie"
          />
          <TextFieldLive
            code="demenagement_telecopieur"
            v-model="item.telecopieur"
            :live="liveSasDemenagement(26713, item)"
            :opqIf="item.jeSouhaiteDemenagerCettePharmacie"
          />
          <FileInput
            code="demenagement_bail"
            :file="item.documentsJustificatifs"
            :live="liveSasDemenagement(26714, item)"
            :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
            :opqIf="item.jeSouhaiteDemenagerCettePharmacie"
          />
        </template>
      </data-iterator>
    </div>
    <validate
      :that="!conditionDemenagement || (conditionDemenagement && getListDemenagements.some((x) => x.jeSouhaiteDemenagerCettePharmacie))"
      else="condition_demenagement"
    />
  </v-form>
</template>
<script>
import PosteCanada from "@/mixins/PosteCanada"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import OrganisationCardContent from "@/components/Common/OrganisationCardContent.vue"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, PosteCanada, DatesHelpers],
  components: { OrganisationCardContent },
  props: {
    sas: { type: Object }
  },
  data() {
    return {
      loadPosteCanadaOnMount: false,
      prefixPosteCanada: "demenagement_modification"
    }
  },
  computed: {
    sasSociete() {
      return this.sas.sasSociete
    },
    conditionDemenagement() {
      return this.estOui(this.sas.sasSociete.declarerDemenagementPharmacie)
    },
    getListDemenagements() {
      return this.sas.demenagements.filter(
        (demenagement) =>
          !this.sas.ventesPharmacie.some(
            (vente) =>
              vente.ventePharmacie &&
              vente.ventePharmacie.organisationId === demenagement.pharmacieDemenagee.organisationId &&
              vente.dateVente !== null
          ) &&
          !this.sas.fermetures.some(
            (fermeture) =>
              fermeture.pharmacieFermee &&
              fermeture.pharmacieFermee.organisationId === demenagement.pharmacieDemenagee.organisationId &&
              fermeture.dateDeFermeture !== null
          )
      )
    }
  },
  watch: {
    conditionDemenagement(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.getListDemenagements.forEach(this.attachposteCanada)
        })
      }
    }
  },
  mounted() {
    if (this.conditionDemenagement) {
      this.getListDemenagements.forEach(this.attachposteCanada)
    }
  },
  methods: {
    liveSasDemenagement(cle, item) {
      return { endpoint: "sas-demenagement", cle: cle, fileId: item.id }
    },
    liveSasSociete(cle) {
      return { endpoint: "sas-societe", cle: cle, fileId: this.sasSociete.id }
    },
    attachposteCanada(demenagement) {
      if (demenagement.jeSouhaiteDemenagerCettePharmacie) {
        this.addPosteCanadaConfig(demenagement)
      }
    },
    cocherDemenagee(demenagement) {
      if (demenagement.jeSouhaiteDemenagerCettePharmacie) {
        demenagement.isExpanded = true
      }
    },
    estRelocalisation(typeDeDemenagement) {
      return this.getCatalogueCodeById("25121", typeDeDemenagement) === "REL"
    },
    estDemenagementOuRelocalisation(typeDeDemenagement) {
      return this.getCatalogueCodeById("25121", typeDeDemenagement) === "DEM" || this.estRelocalisation(typeDeDemenagement)
    }
  }
}
</script>

<style></style>